import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';
import Project from './class';

export const actions = {
  REQUEST: 'Dora/all-projects/REQUEST',
  RECEIVE: 'Dora/all-projects/SUCCESS',
  FAIL: 'Dora/all-projects/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'projects',
  actions,
  requestDataCall: (store, params) =>
    API.get('projects', params).then((res) => res.map((p) => new Project(p))),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/projects/duck.js